<!-- <app-header></app-header>
<app-breadcrumb></app-breadcrumb> -->
<div class="wrapper">
  <div class="header">
    <div class="title">
      <span class="custom_subtiles2">Organizational Compliance</span>
    </div>
    <div class="search-bar">
      <button type="submit" class="msicon"><span class="material-symbols-outlined">
          search</span></button>
      <input type="search" class="search form-control" [(ngModel)]="searchText" placeholder="Search For Compliance Name or Compliance Type"
        (keyup)="applyFilter($event.target.value)">
      <button type="submit" class="msicon" [style.display]="searchText.length > 0 ? 'block': 'none'"><span
          class="material-symbols-outlined" (click)="clearSearchText()"> close </span></button>
    </div>
    <!-- Filter by dropdowns -->
    <div class="filter_section">
      <span class="labelName fs-14 mr-1"> Filter by:</span>
      <!-- <div class="select-filter" >
        <mat-form-field appearance="fill" class="custom_select">
          <mat-select (selectionChange)="regionChange($event.value)" placeholder="Select Region">
            <mat-option value="0">All Regions</mat-option>
            <mat-option *ngFor="let region of regions" [value]="region.id">{{ region.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
      <div class="select-filter">
        <mat-form-field appearance="fill" class="custom_select">
          <mat-select (selectionChange)="yearChange($event.value)" placeholder="Select Year" [(ngModel)]="selectedYear">
            <mat-option value="0">All Years</mat-option>
            <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div>
        <button mat-flat-button class="custom_btn primary_btn_base" (click)="OpenCompDialog()">Add Compliance</button>
      </div>
    </div>
  </div>
  <div class="row m-0">
    <div class="col-12 p-0 accordion_section compliance-tabgroup" >
      <mat-tab-group mat-stretch-tabs="false" style="display: flex;" mat-align-tabs="start" (selectedTabChange)="getCountryData($event)">
        <mat-tab *ngFor="let data of headerRegionsTab" [label]="data.name"></mat-tab>
      </mat-tab-group>
    </div>

    <div class="mat-elevation-z8 col-12 p-0 pt-2 compliacne-table">
      <div style="overflow-x: auto; max-height: 495px;" *ngIf="(totalRecords > 0)">
        <table mat-table [dataSource]=" dataSource" class="mat-table styled-table">
          <!-- Compliance Name Column -->
          <ng-container matColumnDef="complianceName">
            <th mat-header-cell *matHeaderCellDef rowspan="5">Compliance Name</th>
            <td mat-cell *matCellDef="let element"> {{element.compilanceName}} </td>
          </ng-container>

          <!-- Compliance Type Column -->
          <ng-container matColumnDef="complianceType">
            <th mat-header-cell *matHeaderCellDef rowspan="5" style="max-width: 185px;min-width: 150px;">Compliance Type
            </th>
            <td mat-cell *matCellDef="let element"> {{element.compilanceType}}</td>
          </ng-container>


          <!-- Dynamic Countries Header -->
          <ng-container *ngFor="let region of sortedData">
            <ng-container matColumnDef="{{region.name}}">
              <th mat-header-cell *matHeaderCellDef [attr.colspan]="getCountryColspan(region)"> {{region.name}} </th>
            </ng-container>
          </ng-container>

          <!-- Dynamic Cities Header -->
          <ng-container *ngFor="let region of sortedData">
            <ng-container *ngFor="let country of region.countryList">
              <ng-container matColumnDef="{{country.name}}">
                <th mat-header-cell *matHeaderCellDef [attr.colspan]="getCityColspan(country)"> {{country.name}} </th>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- Dynamic Office Locations Header -->
          <ng-container *ngFor="let region of sortedData">
            <ng-container *ngFor="let country of region.countryList">
              <ng-container *ngFor="let city of country.cityList">
                <ng-container matColumnDef="{{city.name}}">
                  <th mat-header-cell *matHeaderCellDef [attr.colspan]="getOfficeColspan(city)"> {{city.name}} </th>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- Office Location Columns -->
          <ng-container *ngFor="let region of sortedData">
            <ng-container *ngFor="let country of region.countryList">
              <ng-container *ngFor="let city of country.cityList">
                <ng-container *ngFor="let location of city.locationList">
                  <ng-container matColumnDef="{{location.name}}">
                    <th mat-header-cell *matHeaderCellDef> {{location.name}}</th>
                    <td mat-cell *matCellDef="let element">
                      <span class="material-symbols-outlined fs-18" *ngIf="element.locationClasses[location.name]"
                        [style.color]="element.locationClasses[location.name] == 'cancel'? '#fa0e0e': element.endDate >currentDate?'#12ff12':'#fa0e0e'">
                        {{element.locationClasses[location.name]}}
                      </span>
                       <p  style="margin-bottom: 0px;"*ngIf="!element.locationClasses[location.name]">{{'NA'}}</p>
                    </td>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>


          <!-- Actions Column -->
          <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef rowspan="5">Actions</th>
            <td mat-cell *matCellDef="let row" style="white-space: nowrap;">
              <span class="material-symbols-outlined action_icon ml-2" (click)="edit(row)">
                edit
              </span>
              <span class="material-symbols-outlined action_icon" (click)="view(row)">
                visibility
              </span>
              <span class="material-symbols-outlined action_icon" (click)="download(row)">
                cloud_download
              </span>
              <span class="material-symbols-outlined action_icon" (click)="delete(row)">
                delete
              </span>
            </td>
          </ng-container>

          <!-- Header Row Definitions -->

          <tr mat-header-row class="countryheaderrow" *matHeaderRowDef="getCountryHeaders()"></tr>
          <tr mat-header-row class="cityheaderrow" *matHeaderRowDef="getCityHeaders()"></tr>
          <tr mat-header-row  class="officeheaderrow" *matHeaderRowDef="getOfficeHeaders()"></tr>

          <!-- Data Row -->
          <tr class="bots" mat-row *matRowDef="let row; columns: displayedColumns;">
          </tr>
          <tr class="bots" mat-row>
            <td>data</td>
          </tr>
        </table>
      </div>
      <div class="no_data" *ngIf="!(totalRecords > 0) && !loading">
        No Records
      </div>
      <mat-paginator class="mb-2 bder-top" [length]="totalRecords" [pageSize]="5" [pageSizeOptions]="[5,20,30,50]"
        aria-label="Select page" (page)="getPaginatorData($event)">
      </mat-paginator>
    </div>
  </div>
  <ng-template let-data #myInfoDialog>
    <h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
      <span>Download "{{data.names}}" Compliance Certificates</span>
      <i mat-dialog-close class="fa fa-times model_close cursor-pointer"></i>
    </h1>
    <div mat-dialog-content class="popup-content">
      <div *ngFor="let doc of locName">
        <div  class="file-row">
        <div class="h5">
          {{doc.fileName}} 
        </div>
        <div>
          <span class="material-symbols-outlined cursor-pointer" [ngClass]="{'disabled-button': canDownload}"
            (click)="downloadProposalArtifacts(doc)">
            download
          </span>
        </div>
      </div>
        <div style="font-weight: 600;">{{location}}
          </div>
          <div class="h5">
          {{'('+ doc.locationName + ')'}}
        </div>
       
      </div>
    </div>
    <div mat-dialog-actions class="popup-buttons d-flex justify-content-end">
      <button mat-dialog-close class="custom_btn inverted_btn_base">
        Close
      </button>

    </div>
  </ng-template>
</div>